import { Dialog } from '@busybusy/webapp-react-ui';
import { EquipmentSelectionOptions } from '__generated__/graphql';
import classNames from 'classnames';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { ClassName } from 'types/ClassName';
import IPosition from 'types/Position';
import { useFeatureFlags } from 'utils/features';
import { t } from 'utils/localize';
import RequireEquipmentForm from '../forms/RequireEquipmentForm';
import { equipmentRequireKeyStringLookup } from '../util/constants';

export interface IRequireEquipmentDetailProps {
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
  className?: ClassName;
}

function RequireEquipmentDetail({ position, onUpdate, editable, className }: IRequireEquipmentDetailProps) {
  const equipmentSelectionRequirement = position.equipmentSelectionRequirement ?? EquipmentSelectionOptions.Off;

  const editTitleDialog = useOpenable();
  const clockInRestrictionToggled = useFeatureFlags('CLOCK_IN_RESTRICTION');

  function onSubmit() {
    editTitleDialog.close();
    onUpdate();
  }

  const classes = classNames('require-equipment-detail', className);

  return (
    <>
      <ProDetailsItem
        title={t('Require Equipment (Clock Only)')}
        onClick={editTitleDialog.open}
        value={equipmentRequireKeyStringLookup[equipmentSelectionRequirement]}
        hint={t(
          'When clocking their own time, require employees to either select equipment or explicitly opt out of the selection. Employees can still be assigned non-equipment time through Supervisor actions.'
        )}
        className={classes}
        disabled={!editable || !clockInRestrictionToggled}
      />
      <Dialog position={'center'} isOpen={editTitleDialog.isOpen} onClose={editTitleDialog.close}>
        <RequireEquipmentForm
          className="mt-4 p-8"
          onSubmit={onSubmit}
          positionId={position.id}
          currentSetting={equipmentSelectionRequirement}
        />
      </Dialog>
    </>
  );
}

export default RequireEquipmentDetail;
